import { Chart } from '@frontend/chart/types';

export const LENDING_EQUIPMENT_USES_VOLUME_BY_PRODUCT_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'Impact drill', data: [{ label: 'full_period', value: 42 }] },
        { name: 'Torque wrench', data: [{ label: 'full_period', value: 31 }] },
        { name: 'Multimeter', data: [{ label: 'full_period', value: 18 }] },
        { name: 'Ladder kit', data: [{ label: 'full_period', value: 12 }] },
        { name: 'Cable tester', data: [{ label: 'full_period', value: 7 }] },
        { name: 'Safety harness', data: [{ label: 'full_period', value: 4 }] },
        { name: 'Laser level', data: [{ label: 'full_period', value: 3 }] },
        { name: 'Inspection camera', data: [{ label: 'full_period', value: 1 }] }
    ]
};
